import { render, staticRenderFns } from "./view-contract.vue?vue&type=template&id=0191cd0c&scoped=true"
import script from "./view-contract.vue?vue&type=script&lang=js"
export * from "./view-contract.vue?vue&type=script&lang=js"
import style0 from "./view-contract.vue?vue&type=style&index=0&id=0191cd0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0191cd0c",
  null
  
)

export default component.exports